import { fetchData, uploadData } from "../utils/api";

export const sliderService = {
  async getSliders() {
    const response = await fetchData("/slider");
    return {
      sliders: response.sliders || response || [],
    };
  },

  async addSlider(formData) {
    const response = await uploadData("/slider", formData);
    return response.slider || response;
  },

  async updateSlider(id, formData) {
    const response = await uploadData(`/slider/${id}`, formData, "PUT");
    return response.slider || response;
  },

  async deleteSlider(id) {
    const response = await fetchData(`/slider/${id}`, { method: "DELETE" });
    return response;
  },
};